import { useEffect, useRef, useImperativeHandle } from "react";

export function useAutoResize(forwardedRef?: React.Ref<HTMLTextAreaElement>) {
  const localRef = useRef<HTMLTextAreaElement>(null);

  useImperativeHandle(forwardedRef, () => localRef.current!, []);

  useEffect(() => {
    const textarea = localRef.current;
    if (!textarea) return;

    const resize = () => {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    };

    textarea.addEventListener("input", resize);
    resize();

    return () => {
      textarea.removeEventListener("input", resize);
    };
  }, []);

  return localRef;
}
